<template>
  <div id="demo-mode">
    <div class="fixed-header1" v-if="TestMode">
      <h1 class="fixed-header-txt1" v>
        <v-icon color="#000000"> mdi-information </v-icon> YOU'RE IN TEST MODE
      </h1>
    </div>
    <div class="fixed-header2" v-else>
      <h1 class="fixed-header-txt2" v>
        <v-icon color="#FFF"> mdi-information </v-icon> YOU'RE IN LIVE MODE
      </h1>
    </div>
  </div>
</template>

<script>
import companyConfig from "@/company_config.json";
export default {
  data() {
    return {
      TestMode: companyConfig.TestMode,
    };
  },
};
</script>

<style lang="scss">
#demo-mode {
  .fixed-header1 {
    width: 100%;
    position: fixed;
    color: #ffffff;
    background-color: #ff0000;
    top: 0;
    z-index: 99;
    height: 25px;
    text-align: center;
  }
  .fixed-header-txt1 {
    font-size: 16px;
    font-weight: bold;
  }
  .fixed-header2 {
    width: 100%;
    position: fixed;
    color: #ffffff;
    background-color: #7fba00;
    top: 0;
    z-index: 99;
    height: 25px;
    text-align: center;
  }
  .fixed-header-txt2 {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }
}
</style>